export enum SeoEndpoints {
  ROBOTS = '/robots',
  ROBOTS_UPDATE = '/robots/update',
}

export interface IRobotsData {
  content: string;
}

// ----------------- DTOs ----------------

export interface IUpdateRobotsDTO {
  content: string;
}

// ------------ Responses --------------

export interface IRobotsResponse {
  data: IRobotsData;
}
